// src/admin/Card.js
import React from 'react';
import { QRCodeSVG } from 'qrcode.react';
import './Card.css';
import bg1 from './BackGround1.png';
import bg2 from './BackGround2.png';
import bg3 from './BackGround3.png';
import bg4 from './BackGround4.png';
import bg5 from './BackGround5.png';

const getFitFontSize = (text, maxWidth = 180, baseSize = 16, minSize = 9) => {
  if (!text) return `${baseSize}px`;
  
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');
  context.font = `bold ${baseSize}px -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif`;
  
  const textWidth = context.measureText(text).width;
  if (textWidth <= maxWidth) return `${baseSize}px`;

  const scaledSize = (maxWidth / textWidth) * baseSize;
  return `${Math.max(minSize, Math.floor(scaledSize * 10) / 10)}px`;
};

const Card = ({ student, selectedBackground, customBackground, cardRefs, handleSelectCard, selectedCards, downloadCard }) => {
  const bgMap = [bg1, bg2, bg3, bg4, bg5];

  let backgroundSrc = '';
  if (selectedBackground === 'custom' && customBackground) {
    backgroundSrc = customBackground;
  } else if (selectedBackground.startsWith('bg-')) {
    const bgNumber = parseInt(selectedBackground.replace('bg-', ''), 10);
    backgroundSrc = bgMap[bgNumber - 1] || bg1;
  }

  const fullNameText = student.fullName || 'N/A';
  const calculatedFontSize = getFitFontSize(fullNameText, 180, 16, 9);

  return (
    <tr key={student.id}>
      <td className="card-checkbox-cell">
        <input
          type="checkbox"
          className="card-checkbox"
          checked={selectedCards.includes(student.id)}
          onChange={() => handleSelectCard(student.id)}
        />
      </td>
      <td>
        <div className="card-container-box">
          <div
            className="card"
            ref={(el) => (cardRefs.current[student.id] = el)}
          >
            {backgroundSrc && (
              <img
                src={backgroundSrc}
                alt="Card Background"
                className="background-img"
                crossOrigin="anonymous"
              />
            )}
            <div className="header card-header-text">
              GIÁO XỨ AN NHƠN
              <br />
              XỨ ĐOÀN PHAOLÔ LÊ VĂN LỘC
            </div>
            <img src="/logo.png" alt="Logo" className="logo" crossOrigin="anonymous" />
            <div className="content content-card">
              <div>
                <b>THẺ THIẾU NHI</b>
              </div>
            </div>
            <div className="qr-code">
              {/* Lồng QRCodeSVG vào div riêng */}
              <div className="qr-wrapper">
                {student.id ? (
                  <QRCodeSVG
                    value={student.id}
                    size={65}
                    level="M"
                    className="qr-code-svg"
                  />
                ) : (
                  <p className="card-no-qr">Không có QR Code</p>
                )}
              </div>

              <div className="id-text">
                {student.id}
              </div>
              <p className="holyName">
                <b>{student.holyName || 'N/A'}</b>
              </p>
              
              <p className="fullName">
                <b style={{ fontSize: calculatedFontSize }}>
                  {fullNameText}
                </b>
              </p>

              <p className="link-home">
                thieunhigiaoxuannhon.com
              </p>
            </div>
          </div>
        </div>
      </td>
      <td className="card-checkbox-cell">
        <button
          onClick={() => downloadCard(student.id)}
          className="card-download-btn"
        >
          Tải về
        </button>
      </td>
    </tr>
  );
};

export default Card;